import React from 'react'
import Loader from '../loader'

const DynamicLoader = () => (
  <div>
    <div className="loader-container">
      <Loader />
    </div>
  </div>
)

export default DynamicLoader
